import { render, staticRenderFns } from "./FootballTeamCard copy.vue?vue&type=template&id=0f089a59&scoped=true"
import script from "./FootballTeamCard copy.vue?vue&type=script&lang=js"
export * from "./FootballTeamCard copy.vue?vue&type=script&lang=js"
import style0 from "./FootballTeamCard copy.vue?vue&type=style&index=0&id=0f089a59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f089a59",
  null
  
)

export default component.exports